export default "__VITE_ASSET__Diq$ExfZ__"